import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils/ui";

interface ClientLoadingStateProps {
  className?: string;
}

const ClientLoadingState = ({ className }: ClientLoadingStateProps) => {
  return (
    <div
      className={cn(
        "w-full",
        className
      )}
    >
      <div className="w-full">
        <div className="mx-auto mt-4 flex min-h-40 w-full flex-col border-b text-card-foreground md:w-[90%]">
          <div className="flex w-full grow flex-row flex-wrap items-center gap-2 p-6 md:p-0">
            <div className="flex w-full items-start gap-3 sm:items-center">
              <div className="mr-2 flex shrink-0 flex-col items-center gap-2 sm:items-start">
                <Skeleton className="h-14 w-14 rounded-md" />
                <Skeleton className="h-5 w-20 rounded-full sm:hidden" />
              </div>

              <div className="min-w-0 flex-1 space-y-3">
                <div className="flex flex-wrap items-center gap-3">
                  <Skeleton className="h-8 w-48" />
                  <Skeleton className="hidden h-6 w-24 rounded-full sm:block" />
                </div>
                <Skeleton className="h-4 w-56" />
                <Skeleton className="h-4 w-32" />
              </div>

              <div className="ml-auto flex flex-wrap items-center gap-2">
                <Skeleton className="h-10 w-24" />
                <Skeleton className="h-10 w-20" />
                <Skeleton className="h-10 w-28" />
              </div>
            </div>
          </div>

          <div className="flex w-max gap-6 px-2 pb-2 md:px-0">
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-8 w-20" />
          </div>
        </div>

        <div className="mx-auto mt-4 grid w-full gap-4 px-4 md:w-[90%] md:px-0 lg:grid-cols-[minmax(0,2fr)_minmax(320px,1fr)]">
          <div className="space-y-4">
            <div className="rounded-xl border p-6">
              <div className="space-y-3">
                <Skeleton className="h-6 w-40" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-11/12" />
                <Skeleton className="h-4 w-4/5" />
              </div>
            </div>

            <div className="rounded-xl border p-6">
              <div className="space-y-4">
                <Skeleton className="h-5 w-32" />
                <div className="grid gap-3 sm:grid-cols-2">
                  <Skeleton className="h-24 w-full" />
                  <Skeleton className="h-24 w-full" />
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-xl border p-6">
            <div className="space-y-4">
              <Skeleton className="h-5 w-28" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-32 w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientLoadingState;
